import * as _ from 'underscore';

// TODO: Maybe move to the @tableau/data-structures module

/**
 * An immutable "set" of items.
 */
export type ItemsSet<T, K extends string = string> = Readonly<{ [key in K]?: T }>;

/**
 * A "set" of keys; membership in the set is defined by the key's existence.
 */
export type KeySet<K extends string> = ItemsSet<true, K>;

export function makeKeySet<K extends string>(...items: K[]): KeySet<K> {
  return _.object(items.map(item => ([ item, true ]))) as KeySet<K>;
}

export function makeItemsSet<T, K extends string>(getKey: (item: T) => K, ...items: T[]): ItemsSet<T, K> {
  if (items.length === 0) {
    return {} as ItemsSet<T, K>;
  }

  return _.object(items.map(getKey), items) as ItemsSet<T, K>;
}

// TODO: Maybe put these functions in a namespace and write unit tests for them

export function isSubsetOf<T, K extends string>(subset: ItemsSet<T, K>, superset: ItemsSet<T, K>): boolean {
  for (const key in subset) {
    if (!superset.hasOwnProperty(key) || superset[key] !== subset[key]) {
      return false;
    }
  }
  return true;
}

export function isEmpty<T>(set: ItemsSet<T>) {
  return !sizeIsAtLeast(set, 1);
}

export function sizeIsAtLeast<T>(set: ItemsSet<T>, minSize: number) {
  let size = 0;

  for (const key in set) {
    if (set.hasOwnProperty(key)) { size++; }
    if (size >= minSize) { return true; }
  }

  return false;
}
